import React, { Component, Fragment } from 'react';
import { FormControlLabel, Radio, Typography, Button } from '@material-ui/core';
import TestSelect4 from '../TestSelect4';

import { connect } from 'react-redux';
import axios from 'axios';

class Step2 extends Component {

    state = {
        groups: [],
        getGroupsErrorMessage: '',
        groupsFetching: true
    }

    componentDidMount = () => {
        const { user: { email }} = this.props;
       
        axios.get(`/api/groups?email=${email}`)
            .then((resp) => {
                console.log(resp)
                this.setState({ groups: resp.data.groups })
            })
            .catch((err) => {
                console.log(err)
                this.setState({ getGroupsErrorMessage: err.response.data.error })
            })
            .finally(() => {
                this.setState({ groupsFetching: false })
                if (this.state.groups.length <= 0) {
                    this.props.handleSelectTypeByClick("1");
                }
            })
    }


    logoutHandler = () => {
        window.location.href = ('/auth/logout');
    }


    render() {
        const { handleGroupSelect, onStep2Click, selectType, handleSelectTypeChange, handleSelectTypeByClick } = this.props;
        const {selectedGroup ,createGroupName } = this.props
        return (
            <div className="step2-wrapper ">
                {!this.state.groupsFetching ?
                    <Fragment>
                        {(!this.state.getGroupsErrorMessage) ? (
                            <Fragment>
                                <div>
                                    <Typography style={{ textAlign: 'center' }} variant='h5' className='title-text'>
                                    Messaging Bridge - Widget Setup
                                    </Typography>
                                </div>
                                <div style={{ flexGrow: 1 }}>
                                    <div style={{ marginTop: 50 }} onClick={() => handleSelectTypeByClick("0")}>
                                        {this.state.groups.length > 0 ?
                                            <Fragment>
                                                <FormControlLabel
                                                    control={
                                                        <Radio
                                                            value="0"
                                                            color='primary'
                                                            onChange={handleSelectTypeChange}
                                                            checked={selectType === "0"}
                                                        />
                                                    }
                                                    label="Select an existing Team / Channel"
                                                />

                                                <TestSelect4
                                                    onGroupSend={handleGroupSelect}
                                                    groups={this.state.groups}
                                                    selectedGroup={selectedGroup}
                                                />
                                            </Fragment> : null
                                        }
                                    </div>
                                    <div style={{ marginTop: 50 }}>
                                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                                            <FormControlLabel
                                                control={
                                                    <Radio
                                                        value="1"
                                                        color='primary'
                                                        onChange={handleSelectTypeChange}
                                                        checked={selectType === "1"}
                                                    />
                                                }
                                                label="Create a new Team"
                                            />
                                            <input
                                                onClick={() => handleSelectTypeByClick("1")}
                                                className='step2-input'
                                                defaultValue={createGroupName}
                                                ref={ref => this.createGroupRef = ref}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className='step2-button-container'>
                                    <Button variant="outlined"
                                        color='primary'
                                        onClick={this.logoutHandler}
                                    >Sign Out</Button>
                                    <Button
                                        onClick={() => onStep2Click(selectType, this.createGroupRef.value)}
                                        variant="contained"
                                        color='primary'
                                        value='Next'
                                    >
                                        Next
                                    </Button>
                                </div>
                            </Fragment>
                         ) : null} 

                        {(this.state.getGroupsErrorMessage) ?
                            <div className="step2-getGroupsErrorWrapper">
                                <Typography>{this.state.getGroupsErrorMessage}</Typography>
                                <div className="step2-button-container">
                                    <Button variant="outlined"
                                        color='primary'
                                        onClick={this.logoutHandler}
                                    >Sign Out</Button>
                                </div>
                            </div> : null
                        }
                    </Fragment> :
                    <Fragment>
                        <div className="step2-getGroupsErrorWrapper">
                            <Typography>
                                one moment please..
                    </Typography>
                        </div>
                    </Fragment>}


            </div>
        )
    }
}

const mapStateToProps = ({ user }) => ({ user });

export default connect(mapStateToProps)(Step2) 



// WEBPACK FOOTER //
// ./src/containers/widget/components/Steps/Step2.js